import { render } from "./AddBusiness.vue?vue&type=template&id=0ec2d628&scoped=true"
import script from "./AddBusiness.vue?vue&type=script&lang=js"
export * from "./AddBusiness.vue?vue&type=script&lang=js"

import "./AddBusiness.vue?vue&type=style&index=0&id=0ec2d628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec2d628"]])

export default __exports__